import type { MaterialNames } from "@/components/material_symbol_names";
import { normalizeExperienceCompetencyName, type ExperienceIndexCategoryId } from "./experienceIndexCategories";

// Material Symbols closest to membership-mobile-app Skills Index icons
// (`CATEGORY_ICONS` / `COMPETENCY_ICONS` in SkillsIndexResultsScreen.tsx).
export const EXPERIENCE_INDEX_CATEGORY_ICONS: Record<ExperienceIndexCategoryId, MaterialNames> = {
  all: "grid_view",
  "business-administration": "work",
  "people-communication": "groups",
  "coaching-development": "school",
  "facility-program-operations": "storefront"
};

const EXPERIENCE_INDEX_COMPETENCY_ICONS: Record<string, MaterialNames> = {
  admin: "assignment",
  budget: "calculate",
  "course maintenance": "park",
  "financial acumen": "show_chart",
  "food & beverage": "restaurant",
  "golf academy": "sports_golf",
  merchandise: "sell",
  network: "group",
  operator: "settings",
  personnel: "badge",
  "public speaking": "mic",
  "social media": "campaign",
  "teaching and coaching": "school",
  technology: "devices",
  "tournament operations": "emoji_events"
};

const DEFAULT_COMPETENCY_ICON: MaterialNames = "assignment";

export function getExperienceIndexCompetencyIcon(competencyName: string): MaterialNames {
  return (
    EXPERIENCE_INDEX_COMPETENCY_ICONS[normalizeExperienceCompetencyName(competencyName)] ?? DEFAULT_COMPETENCY_ICON
  );
}
